<h1 mat-dialog-title>
  {{ 'igo.geo.layer.saveFeatureInLayer' | translate }}
</h1>

<div mat-dialog-content>
  <form class="igo-form" [formGroup]="form">
    <igo-list [navigation]="false" [selection]="false">
      <igo-search-results-item
        igoListItem
        color="accent"
        [result]="feature"
        [showIcons]="true"
      />
    </igo-list>

    <div class="igo-input-container">
      <mat-form-field>
        <input
          type="text"
          placeholder="{{ 'igo.geo.layer.chooseOrSet' | translate }}"
          matInput
          [matAutocomplete]="auto"
          formControlName="layerName"
        />
        <mat-autocomplete [displayWith]="displayFn" #auto="matAutocomplete">
          @for (layer of filteredLayers$ | async; track layer) {
            <mat-option [value]="layer">
              {{ layer.title }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions style="justify-content: center">
  <div class="igo-form-button-group create-layer-button-top-padding">
    <button matButton="elevated" type="button" (click)="cancel()">
      {{ 'igo.geo.layer.cancelBtn' | translate }}
    </button>
    <button
      id="createLayerBtnDialog"
      matButton="elevated"
      type="button"
      color="primary"
      (click)="save()"
    >
      {{ 'igo.geo.layer.saveBtn' | translate }}
    </button>
  </div>
</div>
